import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { AssistanceConversationsInterface } from '@app/interface/assistance-conversations';

@Injectable({
  providedIn: 'root',
})
export class AssistanceConversationsApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient, // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllConversations<T = AssistanceConversationsInterface>(
    organization_id: number | null,
    params: httpQueryParams = {},
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/conversation/`;
    return this.getRecursivePage<T>(path, params);
  }

  public getSpecificConversation<T = AssistanceConversationsInterface>(
    organization_id: number | null,
    id: number,
    params: httpQueryParams = {},
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/conversation/${id}/`;
    return this.getRecursivePage<T>(path, params);
  }

  public createConversations(
    organization_id: number | null,
    conversationtData: Partial<AssistanceConversationsInterface>,
  ): Observable<AssistanceConversationsInterface> {
    if (!conversationtData.organization_id) {
      conversationtData.organization_id = 1; // Default to company with ID 1
    } else {
      organization_id = conversationtData.organization_id;
    }
    const path = `api/${organization_id}/conversation/`;

    return this.post<AssistanceConversationsInterface>(
      path,
      {},
      conversationtData,
    );
  }

  public updateConversations(
    organization_id: number | null,
    id: number,
    data: Partial<AssistanceConversationsInterface>,
  ): Observable<AssistanceConversationsInterface> {
    // console.log(data);
    return this.partialUpdate<AssistanceConversationsInterface>(
      `api/${organization_id}/conversation/${id}/`,
      {}, //{ withCredentials: true },
      data,
    );
  }
}
